module.exports = __webpack_public_path__ + "static/media/Spring.617fb499.svg";